import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowRight, Phone } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';

const MobileFixedCTA = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const { t } = useLanguage();

  useEffect(() => {
    const handleScroll = () => {
      // Show CTA after scrolling 300px
      setIsVisible(window.scrollY > 300);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ duration: 0.3, ease: 'easeOut' }}
          className="fixed bottom-0 left-0 right-0 z-50 lg:hidden"
        >
          {/* Gradient fade effect */}
          <div className="absolute inset-0 bg-gradient-to-t from-black via-black/90 to-transparent pointer-events-none" 
               style={{ height: '120%', bottom: 0, top: 'auto' }} />
          
          {/* CTA Container */}
          <div className="relative px-4 pb-4 pt-6">
            {/* Expanded Options */}
            <AnimatePresence>
              {isExpanded && (
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: 20 }}
                  transition={{ duration: 0.2 }}
                  className="mb-3 flex gap-3"
                >
                  {/* Call Button */}
                  <a
                    href="tel:+12155551234"
                    className="flex-1 flex items-center justify-center gap-2 py-3 bg-white/10 backdrop-blur-sm border border-white/20 text-white font-montserrat text-xs tracking-wider uppercase transition-all duration-300 hover:bg-white/20"
                    data-testid="mobile-cta-call"
                  >
                    <Phone className="w-4 h-4" />
                    {t('mobileCta.call') || 'Call Now'}
                  </a>
                </motion.div>
              )}
            </AnimatePresence>

            {/* Main CTA Button */}
            <div className="flex gap-2">
              {/* Expand/Collapse Toggle */}
              <motion.button
                whileTap={{ scale: 0.95 }}
                onClick={() => setIsExpanded(!isExpanded)}
                className="w-12 h-12 flex items-center justify-center bg-white/10 backdrop-blur-sm border border-white/20 text-white transition-all duration-300"
                data-testid="mobile-cta-expand"
              >
                <motion.div
                  animate={{ rotate: isExpanded ? 45 : 0 }}
                  transition={{ duration: 0.2 }}
                >
                  <span className="text-xl font-light">+</span>
                </motion.div>
              </motion.button>

              {/* Main Start Project Button */}
              <Link
                to="/contacto"
                className="flex-1 flex items-center justify-center gap-3 py-4 bg-[#C5A55C] text-black font-montserrat font-medium text-sm tracking-[0.15em] uppercase transition-all duration-300 hover:bg-[#D4B86A] active:scale-[0.98]"
                data-testid="mobile-cta-main"
              >
                {t('mobileCta.startProject') || 'Start Project'}
                <ArrowRight className="w-4 h-4" />
              </Link>
            </div>

            {/* Safe area spacing for devices with home indicator */}
            <div className="h-safe-area-inset-bottom" />
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default MobileFixedCTA;
